import React, { useState, useReducer, useRef, useEffect } from 'react'


//style
import { WrapFilterUsers } from './index.style'
//component
import TitleDropdownFilter from '../../../../../../Control/TitleDropdownFilter'


const DropDownFilterTransTimes = () => {

    const [activeFilter, setActiveFilter] = useState(false)
    const [isShowDropdown, setIsShowDropdown] = useState(false)

    const _handleOpenBox = () => {

    }
    return (
        <WrapFilterUsers >
            <TitleDropdownFilter onClick={_handleOpenBox} active={activeFilter} disabled={true}>
                Thời gian
            </TitleDropdownFilter>
            {/* {
                isShowDropdown &&
                
            } */}
        </WrapFilterUsers>
    )
}

export default DropDownFilterTransTimes
